export const vehicleTypeFilterKey = 'vehicleType';
export const vehicleSubTypeFilterKey = 'vehicleSubType';

export const placeholderOption = {
  label: '-select-',
  value: '',
  defaultValue: true,
  key: 'initialOption',
};
